import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

interface headerState {
  data: any;
  loading: boolean;
  error: string | null;
  activeMenu: any;
  activeMenuLabel: string | null;
  activeMenuLink: string | null;
  isFilterOpen: boolean;
}

const initialState: headerState = {
  data: null,
  loading: false,
  error: null,
  activeMenu: null,
  activeMenuLabel: null,
  activeMenuLink: null,
  isFilterOpen: false,
};

const NEXT_PUBLIC_REACT_APP_API_BASE_URL =
  process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

// Async thunk to fetch header content
export const fetchHeader = createAsyncThunk("header/fetchHeader", async () => {
  const response = await fetch(
    `${NEXT_PUBLIC_REACT_APP_API_BASE_URL}header-v2?populate=deep,8`,
  );
  const data = await response.json();
  return data;
});

const headerSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {
      state.activeMenu = action.payload;
      localStorage.setItem("activeMenu", JSON.stringify(action.payload));
    },
    setActiveMenuLabel: (state, action) => {
      state.activeMenuLabel = action.payload;
      localStorage.setItem("activeMenuLabel", action.payload ?? "");
    },
    setActiveMenuLink: (state, action) => {
      state.activeMenuLink = action.payload;
      localStorage.setItem("activeMenuLink", action.payload ?? "");
    },
    restoreFromLocalStorage: (state) => {
      try {
        const savedLabel = localStorage.getItem("activeMenuLabel");
        const savedLink = localStorage.getItem("activeMenuLink");
        const savedMenu = localStorage.getItem("activeMenu");

        state.activeMenuLabel = savedLabel || null;
        state.activeMenuLink = savedLink || null;
        state.activeMenu = savedMenu ? JSON.parse(savedMenu) : null;
      } catch (e) {
        console.error("Error restoring from localStorage:", e);
      }
    },
    setIsFilterOpen: (state, action) => {
      state.isFilterOpen = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHeader.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHeader.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchHeader.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Failed to fetch header";
      });
  },
});

// ✅ Export everything you need
export const {
  setActiveMenu,
  setActiveMenuLabel,
  setActiveMenuLink,
  restoreFromLocalStorage,
  setIsFilterOpen,
} = headerSlice.actions;

export default headerSlice.reducer;
